let priorScollLocation = 0;
class Slider {
    constructor(idBeginsWith, autoNext){
        this.idBeginsWith = idBeginsWith;
        this.currentIdx = 0;
        this.next();
        this.autoNext = autoNext;
        this.intervalId = -1;
        if (this.autoNext) this.intervalId = setInterval(this.next.bind(this), 5000);
    }
    userPrev() {
        this.prev();
        if (this.autoNext) {
            clearInterval(this.intervalId);
            this.intervalId = setInterval(this.prev.bind(this), 5000);
        }
    }
    userNext() {
        this.next();
        if (this.autoNext) {
            clearInterval(this.intervalId);
            this.intervalId = setInterval(this.next.bind(this), 5000);
        }
    }
    prev() {
        const divs = document.querySelectorAll(`[id^='${this.idBeginsWith}']`);
        divs.forEach(this.processDiv.bind(this));
        this.currentIdx--;
        if (this.currentIdx < 0) this.currentIdx = divs.length - 1;
    }
    next() {
        const divs = document.querySelectorAll(`[id^='${this.idBeginsWith}']`);
        divs.forEach(this.processDiv.bind(this));
        this.currentIdx++;
        if (this.currentIdx >= divs.length) this.currentIdx = 0;
    }
    processDiv(value, key) {
        if (key == this.currentIdx) {
            value.classList.remove("opacity-0");
            value.classList.add("opacity-100");
        } else {
            value.classList.remove("opacity-100");
            value.classList.add("opacity-0");
        }
    }
    reset(idBeginsWith) {
        this.idBeginsWith = idBeginsWith;
        this.currentIdx = 0;
        this.next();
        if (this.autoNext) {
            clearInterval(this.intervalId);
            this.intervalId = setInterval(this.next.bind(this), 5000);
        }
    }
}
new Slider("hero-slideshow-", true);
let roomSlider = new Slider("room-00-slideshow-", true);
let gallerySlider = new Slider("gallery-slideshow-", false);
function activateRoom(roomId) {
    const contents = document.querySelectorAll("[id^='room-content-']");
    contents.forEach(function(value, key) {
        if (key == roomId) {
            value.classList.remove("hidden");
            value.classList.add("flex");
        } else {
            value.classList.add("hidden");
            value.classList.remove("flex");
        }
    });
    const items = document.querySelectorAll("[id^='room-item-']");
    items.forEach(function(value, key) {
        if (key == roomId) value.classList.add("text-cyanish-400");
        else value.classList.remove("text-cyanish-400");
    });
    const links = document.querySelectorAll("[id^='room-link-']");
    links.forEach(function(value, key) {
        if (key == roomId) {
            value.classList.remove("border-transparent");
            value.classList.add("border-cyanish-400");
        } else {
            value.classList.add("border-transparent");
            value.classList.remove("border-cyanish-400");
        }
    });
    roomSlider.reset(`room-${roomId.toString().padStart(2, "0")}-slideshow-`);
}
function getScrollLocation() {
    return Math.max(window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0);
}
// scroll detection
//    https://tailwind-elements.com/snippets/tailwind/tailwindelements/3681385?view=side#js-tab-view
//    https://stackoverflow.com/a/20478983/1913816
//      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
window.onscroll = onScroll;
function onScroll() {
    const scrollLocation = getScrollLocation();
    onScrollNav(scrollLocation);
    onScrollReturnToTop(scrollLocation);
    priorScollLocation = scrollLocation;
}
function onScrollNav(scrollLocation) {
    const nav = document.querySelector("#nav");
    if (nav === null) return;
    const logos = document.querySelectorAll("[id^='logo-']");
    if (priorScollLocation == 0 && scrollLocation > 0) {
        nav.classList.remove("border-transparent", "bg-white/0", "text-white");
        nav.classList.add("bg-white/95", "text-slate-600");
        // hidden because I don't want to make two different nav bars so they can all be absolute w/ z-indexes
        // otherwise just opacity leaves them stacked and we want to trigger opacity transition
        logos.forEach(function(logo, key) {
            if (key == 0) {
                logo.classList.add("opacity-0");
                logo.classList.add("hidden");
            } else {
                logo.classList.remove("hidden");
                // https://cloudfour.com/thinks/transitioning-hidden-elements/
                //    force repaint to unhide and allow transition, hope it's not expensive, but it shouldn't happen on
                //    intial load, so shouldn't affect site metrics
                // @ts-expect-error
                const repaint = logo.offsetHeight;
                logo.classList.remove("opacity-0");
            }
        });
    } else if (priorScollLocation > 0 && scrollLocation == 0) {
        nav.classList.add("border-transparent", "bg-white/0", "text-white");
        nav.classList.remove("bg-white/95", "text-slate-600");
        logos.forEach(function(logo, key) {
            if (key == 0) {
                logo.classList.remove("hidden");
                // https://cloudfour.com/thinks/transitioning-hidden-elements/
                //    force repaint
                console.log(logo.offsetHeight);
                logo.classList.remove("opacity-0");
            } else {
                logo.classList.add("opacity-0");
                logo.classList.add("hidden");
            }
        });
    }
}
function onScrollReturnToTop(scrollLocation) {
    const nav = document.querySelector("#nav");
    if (nav === null) return;
    const rect = nav.getBoundingClientRect();
    const returnToTop = document.querySelector("#return");
    if (returnToTop === null) return;
    if (scrollLocation > rect.height) returnToTop.classList.remove("opacity-0");
    else returnToTop.classList.add("opacity-0");
}
function showModal(startingIdx) {
    const modal = document.getElementById("galleryModal");
    if (modal === null) return;
    gallerySlider.currentIdx = startingIdx;
    gallerySlider.next();
    modal.classList.remove("hidden");
}
function closeModal() {
    const modal = document.getElementById("galleryModal");
    if (modal === null) return;
    modal.classList.add("hidden");
}
function openNarrowNavMenu() {
    const menu = document.getElementById("narrowNavMenu");
    if (menu === null) return;
    menu.classList.remove("hidden");
}
function closeNarrowNavMenu() {
    const menu = document.getElementById("narrowNavMenu");
    if (menu === null) return;
    menu.classList.add("hidden");
}
document.addEventListener("keydown", (event)=>{
    if (event.key === "Escape") {
        closeModal();
        closeNarrowNavMenu();
    }
});
document.addEventListener("click", (event)=>{
    if (event.target === null) return;
    const menu = document.getElementById("narrowNavMenu");
    if (menu === null) return;
    const hamburger = document.getElementById("hamburger");
    if (hamburger === null) return;
    if (!hamburger.contains(event.target) && !menu.contains(event.target)) closeNarrowNavMenu();
});

//# sourceMappingURL=olivia.254d5f7d.js.map
